import { render, staticRenderFns } from "./contacts.vue?vue&type=template&id=14eb6488"
import script from "./contacts.vue?vue&type=script&lang=ts"
export * from "./contacts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports